import { createIconComponent } from '../../factory/create-icon-component';
export const ChevronDownIcon = createIconComponent(
  'ChevronDownIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.61745 16.1872L7.58792 14.1576C5.42501 11.9947 4.34356 10.9133 4.27049 9.98481C4.20708 9.17919 4.53319 8.3919 5.14769 7.86707C5.85589 7.26221 7.38529 7.26221 10.4441 7.26221H15.9243C17.7842 7.26221 18.7142 7.26221 19.2174 7.49431C20.4134 8.04595 20.9843 9.42431 20.5287 10.6601C20.337 11.18 19.6794 11.8376 18.3642 13.1528L18.3642 13.1528L15.4189 16.0981L15.3298 16.1872L15.3298 16.1872C14.3301 17.1869 13.8302 17.6868 13.2538 17.8741C12.7467 18.0389 12.2005 18.0389 11.6935 17.8741C11.1171 17.6868 10.6172 17.1869 9.61745 16.1872Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
